module.exports = require("/home/vsts/work/1/s/src/redux/createStore.ts")